$(document).ready(function(){
    let numberOfLoaders = 1;

    //Добавляет новые загрузчики
    function addsLoader (elem, loaderName, name) {
        numberOfLoaders++
        const inputName = name !== undefined ? name : ''
        elem[0].insertAdjacentHTML('afterend',
            '<div class="reference__loader">\n' +
            `                            <input id="file5${numberOfLoaders}" name="${inputName}" type="file" class="visually-hidden reference__file" style="display: none">\n` +
            `                            <label for="file5${numberOfLoaders}" class="reference__name">\n` +
            `                                <div class="reference__start">${loaderName}</div>\n` +
            '                                <div class="reference__process">\n' +
            '                                    <div class="reference__img-box">\n' +
            '                                        <svg class="reference__file-icon" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
            '                                            <path d="M29.5596 2.8125H4.19769C3.95439 2.8125 3.75732 3.00957 3.75732 3.25287V6.56982H0.440369C0.197067 6.56982 0 6.76689 0 7.01019V26.7361C0 26.9794 0.197067 27.1765 0.440369 27.1765H25.8023C26.0456 27.1765 26.2427 26.9794 26.2427 26.7361V23.4192H29.5596C29.8029 23.4192 30 23.2221 30 22.9788V3.25287C30 3.00957 29.8029 2.8125 29.5596 2.8125ZM0.880737 26.2958V21.684L6.5284 15.5997L12.8101 21.8813C12.9797 22.0509 13.263 22.0509 13.4326 21.8813L22.5146 12.7991L25.3619 15.6466V26.2958H0.880737ZM29.1193 22.5385H26.2427V7.01019C26.2427 6.76689 26.0456 6.56982 25.8023 6.56982H20.6948C20.4515 6.56982 20.2544 6.76689 20.2544 7.01019C20.2544 7.25327 20.4515 7.45056 20.6948 7.45056H25.3619V14.4012L22.8259 11.8652C22.654 11.6931 22.3753 11.6931 22.2034 11.8652L13.1213 20.9473L6.828 14.6537C6.65405 14.4798 6.36154 14.485 6.194 14.6656L0.880737 20.3895V7.45056H18.5518C18.7951 7.45056 18.9922 7.25327 18.9922 7.01019C18.9922 6.76689 18.7951 6.56982 18.5518 6.56982H4.63806V3.69324H29.1193V22.5385Z" fill="#118C27"/>\n' +
            '                                            <path d="M13.1212 8.91815C11.5836 8.91815 10.3325 10.1692 10.3325 11.7068C10.3325 13.2445 11.5836 14.4955 13.1212 14.4955C14.6588 14.4955 15.9099 13.2445 15.9099 11.7068C15.9099 10.1692 14.6588 8.91815 13.1212 8.91815ZM13.1212 13.6148C12.069 13.6148 11.2133 12.7588 11.2133 11.7068C11.2133 10.6547 12.069 9.79889 13.1212 9.79889C14.1732 9.79889 15.0292 10.6547 15.0292 11.7068C15.0292 12.7588 14.1732 13.6148 13.1212 13.6148Z" fill="#118C27"/>\n' +
            '                                        </svg>\n' +
            '                                    </div>\n' +
            '                                    <div class="reference__box">\n' +
            '                                        <div class="reference__file-name">Справка.pdf</div>\n' +
            '                                        <div class="reference__progress">\n' +
            '                                            <div class="reference__loaded"></div>\n' +
            '                                        </div>\n' +
            '                                        <div class="reference__size">189 kb</div>\n' +
            '                                        <div class="reference__error">Файл не должен быть больше 7 Мб</div>\n' +
            '                                    </div>\n' +
            '                                    <div class="reference__close"></div>\n' +
            '                                </div>\n' +
            '                            </label>\n' +
            '                        </div>'
        )
    }

    //Проверяет заполненость и количество загрузчиков в списке
    function checkLoaders (fileBlock) {
        const loaderList = fileBlock.parent('.reference__list')
        const loaders = loaderList.find('.reference__loader')
        // const loaders = $('.reference__loader')
        let checkArray = []

        loaders.each(function () {
            if ($(this).find('.reference__file').val() === '') {
                checkArray.push(false)
            } else {
                checkArray.push(true)
            }
        });

        return loaders.length < 5 && checkArray.indexOf(false) < 0;
    }

    //Проверяет заполненость загрузчиков на всей странице
    function checkFileValue () {
        const allFile = $('.reference__file')
        let checkArray = []

        allFile.each(function () {
            if ($(this).val() === '') {
                checkArray.push(false)
            } else {
                checkArray.push(true)
            }
        });

        return checkArray.indexOf(true) < 0;
    }

    //Загрузка файла
    function readFile(file, fileBlock, fileExtension, fileInput) {
        let reader = new FileReader();
        const name = fileInput.attr('name')
        const startName = fileBlock.find('.reference__start').text();
        const dataLoaderName = fileBlock.find('.reference__start').attr('data-loader-name');
        const loaderName = dataLoaderName ? dataLoaderName : startName;

        reader.readAsDataURL(file);
        // fileBlock.removeClass('error-reference')
        // fileBlock.find('.reference__without').hide();

        //Работа прогресс бара
        reader.onprogress = function(event) {
            const loadedBlock = fileBlock.find('.reference__loaded')
            if (event.lengthComputable) {
                let percentLoaded = ((event.loaded/event.total) * 100) + '%'
                loadedBlock.width(percentLoaded)
            }
        };

        //Прячет прогресс, показывает размер загруженного файла
        reader.onload = function() {
            fileBlock.find('.reference__progress').hide()
            fileBlock.find('.reference__size').text(Math.round((file.size/1000)) + ' kb')
            fileBlock.find('.reference__size').show()
            $('.button--reference').removeClass('button--in-active');

            //Добавляет превью изображения если тип файла jpg, png или jpeg
            if (fileExtension === 'jpg' || fileExtension === 'png' || fileExtension === 'jpeg') {
                fileBlock.find('.reference__file-icon').hide()
                fileBlock.find('.reference__img-box').css('background-image', `url("${reader.result}")`)
            }
        };

        // if (numberOfLoaders >= 5 ) {
        //     console.log('error: ', 'Загрузчикво может быть не больше 5')
        // } else if (!checkLoaders(fileBlock)) {
        //     console.log('error: ', 'Не все загрузчики заполнены')
        // } else {
        //     addsLoader(fileBlock);
        // }

        if (checkLoaders(fileBlock)) {
            addsLoader(fileBlock, loaderName, name);
        }

        reader.onerror = function() {
            fileBlock.find('.reference__progress').hide()
            fileBlock.find('.reference__error').text('Не удалось загрузить файл. Пожалуйста, попробуйте еще раз').show()
        };

    }

    //Отработка изменений при добавлении файла
    $(document).on('change', '.reference__file', function (e) {
        const fileBlock = $(this).parents('.reference__loader')
        const file = e.target.files[0]
        const fileExtension = file.name.split('.').pop();

        //Обновляем показ прогресс бара при повторной загрузке
        fileBlock.find('.reference__progress').show()
        fileBlock.find('.reference__file-icon').show()
        fileBlock.find('.reference__size').hide()
        fileBlock.find('.reference__error').hide()
        fileBlock.removeClass('error-reference')
        $('.reference__without').hide()
        fileBlock.find('.reference__img-box').css('background-image', '')

        //Показ загрузки файла
        fileBlock.find('.reference__name').addClass('reference__name--progress')
        fileBlock.find('.reference__file-name').text(file.name)
        fileBlock.find('.reference__start').hide()
        fileBlock.find('.reference__process').addClass('reference__process--active')

        //Валидация и загрузка файла
        if (file.size > 7000000) {
            fileBlock.find('.reference__progress').hide();
            fileBlock.find('.reference__error').text('Файл не должен быть больше 7 Мб').show();
            $('.button--reference').addClass('button--in-active');
        } else if (fileExtension === 'pdf' || fileExtension === 'jpg' || fileExtension === 'png' || fileExtension === 'jpeg') {
            readFile(file, fileBlock, fileExtension, $(this));
            $('.button').removeClass('button--in-active');
        } else {
            fileBlock.find('.reference__progress').hide();
            fileBlock.find('.reference__error').text('Файл должен быть формата pdf или jpg').show();
            $('.button--reference').addClass('button--in-active');
        }
    })

    //Закрытие загрузки файла
    $(document).on('click', '.reference__close', function (e) {
        e.stopPropagation();
        e.preventDefault();
        const fileBlock = $(this).parents('.reference__loader')
        const fileInput = fileBlock.find('.reference__file')

        fileInput.val('');
        fileBlock.find('.reference__file-icon').show()
        fileBlock.find('.reference__name').removeClass('reference__name--progress')
        fileBlock.find('.reference__start').show()
        fileBlock.find('.reference__process').removeClass('reference__process--active')
        fileBlock.find('.reference__progress').show()
        fileBlock.find('.reference__error').hide()
        fileBlock.find('.reference__img-box').css('background-image', '')

        //Очищаем дата атрибуты
        fileInput.attr('data-ext', '')
        fileInput.attr('data-body', '')

        $('.button--reference').removeClass('button--in-active');
    });

    //Переход на страницу закрытия договора без справки в процессе process
    $('.button--reference').on('click', function (e) {
        e.preventDefault();
        const referenceForm = $('.reference--process')

        $('.reference__without').hide();

        if ($('#file').val() === '') {
            $('.reference__without').show();
        } else {
            referenceForm.submit();
        }
    });

    //Переход на страницу c медицинской справкой в процессе protectionclaim
    $('.button--reference-protectionclaim').on('click', function (e) {
        e.preventDefault();
        const referenceForm = $('.reference--protectionclaim')
        const requiredReferenceFiles = $('.reference__loader:first-child .reference__file')
        let errorShow = false

        requiredReferenceFiles.each(function () {
            if ($(this).attr('required') === 'required' && $(this).val().length === 0) {
                $(this).parents('.reference__loader').addClass('error-reference')

                errorShow = true

                return errorShow
            }
        })

        if ($('#reference__address').val().length === 0) {
            $('#reference__address').addClass('error-input')
            errorShow = true
        }

        if (errorShow) {
            $('.reference__without').show();
        } else {
            referenceForm.submit();
        }
    });

    //Переход на страницу c медицинской справкой в процессе protectionclaim-vnt-page5a
    $('.button--reference-vnt-page5a').on('click', function (e) {
        e.preventDefault();

        const referenceForm = $('.reference--protectionclaim')
        const requiredReferenceFiles = $('.reference__loader:first-child .reference__file')
        let errorShow = false

        requiredReferenceFiles.each(function () {
            if ($(this).attr('required') === 'required' && $(this).val().length === 0) {
                $(this).parents('.reference__loader').addClass('error-reference')

                errorShow = true

                return errorShow
            }
        })

        if (errorShow) {
            $('.reference__without').show();
        } else {
            referenceForm.submit();
        }
    });

    //Переход на страницу c вводом БИК в процессах protectionclaim-vnt и protectionclaim-npr
    $('.button--protectionclaim-address').on('click', function (e) {
        e.preventDefault();
        const referenceForm = $('.reference--protectionclaim-address')
        // referenceForm.submit();
        let errorShow = false

        if ($('#reference__address').val().length === 0) {
            $('#reference__address').addClass('error-input')
            errorShow = true
        }

        if (errorShow) {
            $('.reference__without').show();
        } else {
            referenceForm.submit();
        }
    });

    //Переход на страницу c вводом БИК в процессе protectionclaim
    $('.button--medical-institution').on('click', function (e) {
        e.preventDefault();
        const referenceForm = $('.reference--medical-institution')
        const loader = $('.reference__loader')
        const insurerCheckbox = $('#insurer')
        let errorShow = false

        if (insurerCheckbox.is(':checked')) {
            loader.addClass('disabled')
            if ($('#medical__name').val().length === 0) {
                $('#medical__name').addClass('error-input')
                errorShow = true
            } else if ($('#medical__address').val().length === 0) {
                $('#medical__address').addClass('error-input')
                errorShow = true
            }
        } else {
            referenceForm.submit();
        }

        if (errorShow) {
            $('.reference__without').show();
        } else {
            referenceForm.submit();
        }
    });

    //Переход на страницу c вводом БИК в процессе protectionclaim
    $('.button--medical-institution-losses').on('click', function (e) {
        e.preventDefault();
        const referenceForm = $('.reference--medical-institution')
        const requiredReferenceFiles = $('.reference__loader:first-child .reference__file')
        // const loader = $('.reference__loader')
        // const insurerCheckbox = $('#insurer')
        const selectCurrentPlace = $('.select__current--place');
        let errorShow = false

        if (selectCurrentPlace.text() === 'Загрузить справку') {
            requiredReferenceFiles.each(function () {
                if ($(this).attr('required') === 'required' && $(this).val().length === 0) {
                    $(this).parents('.reference__loader').addClass('error-reference')

                    errorShow = true

                    return errorShow
                }
            })
        } else {
            if ($('#medical__name').val().length === 0) {
                $('#medical__name').addClass('error-input')
                errorShow = true
            } else if ($('#medical__address').val().length === 0) {
                $('#medical__address').addClass('error-input')
                errorShow = true
            }
        }

        if (errorShow) {
            $('.reference__without').show();
        } else {
            referenceForm.submit();
        }
    });

    $('#reference__address').on('input', function () {

        if ($('#reference__address').val().length) {
            $('.button--reference-sbol').removeClass('button--in-active')
        } else if (!$('#reference__address').val().length && checkFileValue()) {
            $('.button--reference-sbol').addClass('button--in-active')
        }
        if($(this).hasClass('kladr-error')){
            $(this).val('')
        }
    });

    //Переход на страницу c вводом БИК в процессе presurvival-reference
    $('.button--reference-presurvival-reference').on('click', function (e) {
        e.preventDefault();

        const referenceForm = $('.reference--presurvival')
        const requiredReferenceFiles = $('.reference__loader:first-child .reference__file')
        let errorShow = false

        requiredReferenceFiles.each(function () {
            if ($(this).attr('required') === 'required' && $(this).val().length === 0) {
                $(this).parents('.reference__loader').addClass('error-reference')

                errorShow = true

                return errorShow
            }
        })

        if (errorShow) {
            $('.reference__without').show();
        } else {
            referenceForm.submit();
        }
    });

    //Скрыть/показать форму страховщика
    $(document).on('change', '#insurer', function() {
        if ($('#insurer').is(':checked')) {
            $('.number--medical-institution').slideDown()
            $('.button--medical-institution').removeClass('button--in-active');
        } else {
            $('.number--medical-institution').slideUp()
            if (checkFileValue()) {
                $('.button--medical-institution').addClass('button--in-active');
            }
        }
    });

    //Скрыть/показать загрузчик
    $('.js-show-loader').on('click', function () {
        const loaderList = $(this).parent('.reference__block').find('.reference__list')
        const plus = $(this).parent('.reference__block').find('.title__plus')

        loaderList.slideToggle();
        plus.toggleClass('title__plus--active')
    });

    //Убирает показ ошибки при вводе информации в поле
    $('.number__input').on('input', function () {
        $(this).removeClass('error-input')
        $('.reference__without').hide();
    })

    //Дизейблим заполнение загрузчика при кликнутой галочке на странице protectionclaim/medical-institution
    $('#insurer').on('change', function () {
        $('.reference__loader').toggleClass('disabled')
    })

    //Проверка кликнутой галочки на странице protectionclaim/medical-institution при первой загрузке (вдруг кнопку назад нажали)
    if ($('#insurer').is(':checked')) {
        $('.reference__loader').addClass('disabled')
    }

    //Переход на страницу с вводом БИК в процессе survival
    $('.button--reference-survival').on('click', function (e) {
        e.preventDefault();
        const referenceForm = $('.reference--survival-index')
        const requiredReferenceFiles = $('.reference__loader:first-child .reference__file')
        let errorShow = false

        requiredReferenceFiles.each(function () {
            if ($(this).attr('required') === 'required' && $(this).val().length === 0) {
                $(this).parents('.reference__loader').addClass('error-reference')

                errorShow = true

                return errorShow
            }
        })

        if (errorShow) {
            $('.reference__without').show();
        } else {
            referenceForm.submit();
        }
    });

    //Переход на страницу с вводом успешной отправки документов в процессе survival
    $('.button--survival-additional-document').on('click', function (e) {
        e.preventDefault();
        const referenceForm = $('.reference--survival-additional-document')
        const requiredReferenceFiles = $('.reference__loader:first-child .reference__file')
        let errorShow = false

        requiredReferenceFiles.each(function () {
            if ($(this).attr('required') === 'required' && $(this).val().length === 0) {
                $(this).parents('.reference__loader').addClass('error-reference')

                errorShow = true

                return errorShow
            }
        })

        if (errorShow) {
            $('.reference__without').show();
        } else {
            referenceForm.submit();
        }
    });

    //Переход на страницу с вводом БИК в процессе process
    $('.button--necessary').on('click', function (e) {
        e.preventDefault();
        const referenceForm = $('.reference--necessary')
        const requiredReferenceFiles = $('.reference__loader:first-child .reference__file')
        let errorShow = false

        requiredReferenceFiles.each(function () {
            if ($(this).attr('required') === 'required' && $(this).val().length === 0) {
                $(this).parents('.reference__loader').addClass('error-reference')

                errorShow = true

                return errorShow
            }
        })

        if (errorShow) {
            $('.reference__without').show();
        } else {
            referenceForm.submit();
        }
    });

    //Субмит формы и переход по action этой формы
    $('.js-button--submit-form').on('click', function (e) {
        e.preventDefault();
        const referenceForm = $('.js-user-type');
        referenceForm.submit();
    });
});

